import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import Input from "../../../../../../components/input";
import {postCreateLabel} from "../../../../../../../actions/contactsGroupItemActions";
import {withRouter} from "react-router-dom";

class NewLabelPopup extends Component {

    constructor(props){
        super(props);

        this.state = {
            labelNameValue: '',
            isLabelCreationProcessing: false
        };

        this.changeHandler = this.changeHandler.bind(this);
        this.proceed = this.proceed.bind(this);
    }

    componentDidMount(){
        document.getElementById('labelName').focus();
    }

    componentDidUpdate(prevProps){
      if (this.props.gmailAddOnErrorMsgBar !== prevProps.gmailAddOnErrorMsgBar && this.state.isLabelCreationProcessing) {
        this.setState({
            isLabelCreationProcessing: false
        });
    }
  }
  
    changeHandler(e){
        this.setState({
            labelNameValue: e.currentTarget.value
        }, () => {
            if(document.getElementById('labelName').classList.contains('is-invalid')){
                document.getElementById('labelName').classList.remove('is-invalid');
            }
        })
    }

    proceed(e){
        e.preventDefault();
        if(this.state.labelNameValue.trim().length > 0){

            this.setState({
                isLabelCreationProcessing: true
            });

            this.props.postCreateLabel(this.state.labelNameValue);

        } else {
            document.getElementById('labelName').classList.add('is-invalid');
        }

    }

    render() {
        return (
            <div className="new-label-popup p-3">
                <form method="post" onSubmit={this.proceed}>
                    <h2 className="mt-2 mb-0">{this.props.t("createLabelText")}</h2>
                    <div className="py-3">
                        <Input
                            id="labelName"
                            type="text"
                            className="form-control"
                            placeholder={this.props.t("labelName")}
                            onChange={this.changeHandler}
                            value={this.state.labelNameValue}
                            required={true}
                            title={this.props.t("textEmptyField")}
                            aria-describedby="labelNameCheck"
                        />
                        <div id="labelNameCheck" className="invalid-feedback">
                            {this.props.t("textProvideLabel")}
                        </div>
                    </div>
                    {
                            this.props.gmailAddOnErrorMsgBar.length
                            ?
                                <p className="gmail-add-on-msg-bar-error" dangerouslySetInnerHTML={{__html: this.props.gmailAddOnErrorMsgBar[1]}}/>
                            :
                    <div className="text-right">
                        <button type="submit" disabled={this.state.isLabelCreationProcessing === true} className="btn btn-primary">{this.props.t("textSave")}</button>
                    </div>
    }
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
        setGmailAddOnData: state.sharingDetailsReducer.getSharingDetailsPopup,
        gmailAddOnErrorMsgBar: state.msgBarReducer.gmailAddOnMsgBar
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    postCreateLabel: (string) => dispatch(postCreateLabel(string, null, ownProps)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewLabelPopup)));